module.exports = "<div class=\"aside\" id=\"addCard\" content>\n\t<ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-card/template.html
// module id = ./pages/xo-sidebar-add-card/template.html
// module chunks = 0